import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import BlogPosts from "@/views/blog/Posts";
import BlogPost from "@/views/blog/Post";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";
import LeadsTasks from "./views/LeadsTasks";
import Page from "./views/Page.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import Project from "./views/Project.vue";
import Invoices from "@/views/Invoices.vue";
import Invoice from "@/views/Invoice.vue";
import OnLogin from "@/views/OnLogin.vue";
import Setup from "@/views/Setup.vue";
import Portfolio from "@/views/Portfolio.vue";
import Developer from "@/views/Developer.vue";
import axios from "axios";
import Workpage from "@/views/Workpage.vue";
import Review from "@/views/Review.vue";
import {eventBus, vm} from "@/main";
import Api from "./models/Api";
import Leads from "./views/Leads";
import Lead from './views/Lead';
import Funnel from './views/Funnel';
import Confirm from '@/views/Confirm.vue';
import Canban from "./views/Canban";
import Category from "./views/blog/Category";
import Invite from "./views/Invite";
import PortfolioCategory from "./views/site/PortfolioCategory";
import PortfolioWorks from "./views/site/PortfolioWorks";
import ServicePage    from "./views/site/ServicePage";

Vue.use(Router);

const guard = function (to, from, next) {
	// check for valid auth token


	  Api.login(to, next);


};

export default new Router({
	linkExactActiveClass: "active",
	routes: [

		{
			path: "/",
			name: "landing",
			components: {
				header: AppHeader,
				default: Landing,
				footer: AppFooter
			}
		},
		{
			path: "/posts",
			name: "posts",
			components: {
				header: AppHeader,
				default: BlogPosts,
				footer: AppFooter
			}
		},
		{
			path: "/post/:alias/:id//:rand?",
			name: "post",
			components: {
				header: AppHeader,
				default: BlogPost,
				footer: AppFooter

			}

		},
		{
			path: "/canban/:rand?",
			name: "canban",
			components: {
				header: AppHeader,
				default: Canban,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}
		},
		{
			path: "/leadtasks/:rand?",
			name: "leadtasks",
			components: {
				header: AppHeader,
				default: LeadsTasks,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}
		},
		{
			path: "/home/:rand?",
			name: "home",
			components: {
				header: AppHeader,
				default: Home,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}
		},
		{
			path: "/lead/:id/:rand?",
			name: "lead",
			components: {
				header: AppHeader,
				default: Lead,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}

		},
		{
			path: "/confirm/:id/:rand?",
			name: "confirm",
			components: {
				header: AppHeader,
				default: Confirm,
				footer: AppFooter

			},


		},
		{
			path: "/invite/:id/:code/:rand?",
			name: "invite",
			components: {
				header: AppHeader,
				default: Invite,
				footer: AppFooter

			},


		},
		{
			path: "/funnel/:id/:rand?",
			name: "funnel",
			components: {
				header: AppHeader,
				default: Funnel,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}

		},
		{
			path: "/leads/",
			name: "leads",
			components: {
				header: AppHeader,
				default: Leads,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}
		},
		{
			path: "/page/:id",
			name: "page",
			components: {
				header: AppHeader,
				default: Page,
				footer: AppFooter

			}
		},
		{
			path: "/project/:id/:rand?",
			name: "project",
			components: {
				header: AppHeader,
				default: Project,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}
		},
		{
			path: "/portfolio",
			name: "portfolio",
			components: {
				header: AppHeader,
				default: Portfolio,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}
		},
		{
			path: "/invoices",
			name: "invoices",
			components: {
				header: AppHeader,
				default: Invoices,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}
		},
		{
			path: "/invoice/:id/:rand?",
			name: "invoice",
			components: {
				header: AppHeader,
				default: Invoice,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}
		},
		{
			path: "/developer/:username",
			name: "developer",
			components: {
				header: AppHeader,
				default: Developer,
				footer: AppFooter

			},

		},
		{
			path: "/developer/:username/review",
			name: "reviewpage",
			components: {
				header: AppHeader,
				default: Review,
				footer: AppFooter

			},

		},
		{
			path: "/developer/:username/:work_id",
			name: "workpage",
			components: {
				header: AppHeader,
				default: Workpage,
				footer: AppFooter

			},

		},
		{
			path: "/setup",
			name: "setup",
			components: {
				header: AppHeader,
				default: Setup,
				footer: AppFooter

			},
			beforeEnter: (to, from, next) => {
				guard(to, from, next);
			}
		},
		{
			path: "/works",
			name: "works_category",
			components: {
				header: AppHeader,
				default:PortfolioCategory,
				footer: AppFooter

			},

		},
		{
			path: "/works/:category_id",
			name: "works_in_category",
			components: {
				header: AppHeader,
				default:PortfolioWorks,
				footer: AppFooter

			},

		},
		{
			path: "/service/:service_id",
			name: "service_page",
			components: {
				header: AppHeader,
				default:ServicePage,
				footer: AppFooter

			},

		},
		{
			path: "/:alias",
			name: "category_blog",
			components: {
				header: AppHeader,
				default:Category,
				footer: AppFooter

			},

		},



	],
	scrollBehavior: to => {
		if (to.hash) {
			return {selector: to.hash};
		} else {
			return {x: 0, y: 0};
		}
	}
});
